import { ListClinic } from '@chiroup/core/types/Clinic.type';
import React from 'react';
import BillingProfilePanel from './BillingProfilePanel';

type Props = {
  clinic: Partial<ListClinic>;
};

const ClinicDebug: React.FC<Props> = ({ clinic }) => {
  return (
    <div className="p-6 space-y-8">
      <BillingProfilePanel clinicId={clinic.ID!} />
    </div>
  );
};

export default ClinicDebug;
